async function objectUrlToBlob(url: string): Promise<Blob> {
  return fetch(url).then((r) => r.blob());
}

export default objectUrlToBlob;
